// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import {useReducer} from 'react';
import etask from 'zetask';
import {api} from '../../../../toolip/pub/lib/api';

/* eslint-disable */
export enum WHITELIST_SUCCESS_CODES {
    ADDED = 'added',
    REMOVED = 'removed',
}
/* eslint-enable */

/* eslint-disable */
export enum WHITELIST_ERROR_CODES {
    ADD_FAILED = 'add_failure',
    REMOVE_FAILED = 'remove_failure',
}
/* eslint-enable */

type t_wl_action_type =
    | 'reset_state'
    | 'add_ip_pending'
    | 'add_ip_success'
    | 'add_ip_failure'
    | 'remove_ip_pending'
    | 'remove_ip_success'
    | 'remove_ip_failure';

interface i_wl_action {
    type: t_wl_action_type;
    payload?: any;
    error?: string;
}

interface i_wl_state {
    is_adding: boolean;
    is_removing: boolean;
    error: string | null;
    data: any | null;
}

const initial_state: i_wl_state = {
    is_adding: false,
    is_removing: false,
    error: null,
    data: null,
};

const whitelist_reducer = (state: i_wl_state,
    action: i_wl_action): i_wl_state=>
    {
    switch (action.type)
    {
    case 'reset_state':
        return {...initial_state};
    case 'add_ip_pending':
        return {...state, is_adding: true, data: action.payload, error: null};
    case 'add_ip_success':
        return {...state, is_adding: false, data: action.payload, error: null};
    case 'add_ip_failure':
        return {...state, is_adding: false, error: action.error};
    case 'remove_ip_pending':
        return {...state, is_removing: true, data: action.payload,
            error: null};
    case 'remove_ip_success':
        return {...state, is_removing: false, data: action.payload,
            error: null};
    case 'remove_ip_failure':
        return {...state, is_removing: false, error: action.error};
    default:
        return state;
    }
};

export const use_whitelist = ()=>{
    const [state, dispatch] = useReducer(whitelist_reducer, initial_state);
    const add = (ip: string, zone_id: string, ips: string[])=>{
        dispatch({type: 'add_ip_pending', payload: ip});
        return etask(function*(){
            try {
                yield api.zone_update_whitelist(zone_id, ips);
                dispatch({type: 'add_ip_success',
                    payload: WHITELIST_SUCCESS_CODES.ADDED});
                return true;
            } catch(e){
                dispatch({type: 'add_ip_failure',
                    error: WHITELIST_ERROR_CODES.ADD_FAILED});
                return false;
            }
        });
    };
    const remove = (ip: string, zone_id: string, ips: string[])=>{
        dispatch({type: 'remove_ip_pending', payload: ip});
        return etask(function*(){
            try {
                yield api.zone_update_whitelist(zone_id, ips);
                dispatch({type: 'remove_ip_success',
                    payload: WHITELIST_SUCCESS_CODES.REMOVED});
                return true;
            } catch(e){
                dispatch({type: 'remove_ip_failure',
                    error: WHITELIST_ERROR_CODES.REMOVE_FAILED});
                return false;
            }
        });
    };
    const reset = ()=>{ dispatch({type: 'reset_state'}); };
    return {
        state,
        add,
        remove,
        reset,
    };
};
